import { prop } from '@ipfabric/utils/fp/prop';
import { MIN_WINDOW_Z_INDEX } from 'components/DeviceView/deviceViewConstants';
import type { DeviceViewWindows } from 'components/DeviceView/deviceViewTypes';

export const getWindowGreatestZIndex = (
  deviceViewWindows: DeviceViewWindows,
): number =>
  Math.max(MIN_WINDOW_Z_INDEX, ...deviceViewWindows.map(prop('zIndex')));
